import React from 'react'
import Slider from 'react-slick'
import { Box, SpanStyled } from '../../Styled/Elements'
import { PrimaryHeading } from '../../Styled/CustomElements'
import { useTranslation } from 'react-i18next'
import { TabsWrapper } from './Styled'
import { expertiseItems } from '../../data/Data'
import { SliderArrowLeft, SliderArrowRight } from '../../Styled/AllImages'

const TabSecond = () => {
    const { t } = useTranslation();

    const settings = {
        dots: false,
        infinite: true,
        slidesToShow: 5,
        swipeToSlide: true,
        autoplay: false,
        speed: 1000,
        autoplaySpeed: 1500,
        pauseOnHover: false,
        prevArrow: <SliderArrowLeft />,
        nextArrow: <SliderArrowRight />,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    initialSlide: 1
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    }

    return (
        <TabsWrapper className='TabsAboutWrapper'>
            <Box className='tabInnerHeading'>
                <PrimaryHeading HlabelF={t("Our")} HlabelS={t("Expertise")} size='25px' />
            </Box>
            <SpanStyled size='15px' className='tabTxt'>
                {t('tab2_Text')}
            </SpanStyled>
            <Box className='sliderContainer sliderContainerExpertise'>
        
                <Slider {...settings}>
                    {expertiseItems.map((item, index) => (
                        <Box key={index} className='expertiseCol'>
                            <Box className="expertiseImg">
                                {item.img}
                            </Box>
                            <Box className="expertiseTxt">{t(item.expertiseTxt)}</Box>
                        </Box>
                    ))}
                </Slider>
                
            </Box>
        </TabsWrapper>
    )
}

export default TabSecond
